import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold" }, "Departments", -1)
const _hoisted_2 = { class: "m-left-8" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "is-italic m-bottom-12"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Departments", -1)
const _hoisted_9 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Assign Point of Contact", -1)
const _hoisted_13 = {
  key: 0,
  class: "help"
}
const _hoisted_14 = {
  key: 1,
  class: "help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormSelect = _resolveComponent("NrFormSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["is-flex is-align-items-center is-justify-content-space-between", $options.canUpdateRequest ? 'panel-item--editable' : 'p-bottom-8'])
    }, [
      _hoisted_1,
      ($options.canUpdateRequest)
        ? (_openBlock(), _createBlock(_component_NrTooltip, {
            key: 0,
            label: "Edit departments"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NrIconButton, {
                class: "edit-request-assigned-btn",
                icon: { name: 'pencil-alt', type: 'regular' },
                variant: "minimal-neutral",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentAction('assignDept'))),
                "aria-label": "Edit departments"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.request.departments, (department) => {
        return (_openBlock(), _createElementBlock("p", {
          key: department.id,
          class: "m-bottom-12"
        }, [
          ($options.departmentMembersList(department) != '')
            ? (_openBlock(), _createBlock(_component_NrTooltip, {
                key: 0,
                label: $options.departmentMembersList(department)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(department.name), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(department.name), 1))
        ]))
      }), 128)),
      (_ctx.request.departments.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($options.canSeeStaffOnlyItems())
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No departments assigned"))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, "No departments available"))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NrModal, {
      title: "Assign departments",
      show: $options.isAssignDeptModalActive,
      hasSecondaryButton: "",
      disableButtons: _ctx.updatingRequestData,
      secondaryButtonText: "Cancel",
      primaryButtonText: "Assign departments",
      onOnPrimaryClick: $options.updateDepartments,
      onOnSecondaryClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCurrentAction(''))),
      onOnCloseClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCurrentAction('')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_NrSelect, {
              modelValue: _ctx.selectedRequestDepartments,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRequestDepartments) = $event)),
              placeholder: "Search and select department",
              options: $options.filteredDepartments,
              filterable: false,
              loading: _ctx.dataFetchState.departments.fetching,
              hasMore: !_ctx.dataFetchState.departments.end,
              onLoadMore: $options.handleDepartmentScroll,
              onSearch: $options.filterDepartments,
              onOpen: $options.filterDepartments,
              "onOption:selected": $options.selectedDepartment,
              "onOption:deselected": $options.deselectedDepartment,
              "append-to-body": "",
              multiple: ""
            }, {
              label: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue", "options", "loading", "hasMore", "onLoadMore", "onSearch", "onOpen", "onOption:selected", "onOption:deselected"]),
            ($options.showDepartmentInputHelper)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " At least one department is required. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_NrFormSelect, {
              label: "Request visibility",
              name: "visibility",
              modelValue: _ctx.selectedVisibility,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedVisibility) = $event)),
              options: $options.visibilities
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_NrSelect, {
              modelValue: _ctx.newPoc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPoc) = $event)),
              placeholder: "Search and select point of contact",
              options: _ctx.pocOptions,
              filterable: false,
              "append-to-body": "",
              onInput: $options.newPocSelected
            }, {
              label: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onInput"]),
            (_ctx.showPocAutomationHelperText)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, " Point of Contact has been automatically updated. "))
              : (_ctx.showPocManualHelperText)
                ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Point of Contact has been manually updated. "))
                : _createCommentVNode("", true)
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "disableButtons", "onOnPrimaryClick"])
  ]))
}